import { LoadingButton } from "@mui/lab";
import {
  Button,
  Chip,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useUpdateIndustryTagsMutation } from "../../services/profileAPI";
import { CustomDialogTitle } from "../../ui";

export const PROFILE_DIRECTORIES_OPTIONS = [
  "advertising & marketing",
  "design",
  "e-commerce",
  "education",
  "edtech",
  "f&b",
  "fmcg",
  "founders",
  "health & wellness",
  "hospitality",
  "hr, recruitment",
  "internet & tech",
  "law",
  "looking for investors, co-founders, advisors",
  "looking for mentors",
  "media",
  "operations",
  "pr, communications",
  "product & tech",
  "retail",
  "sales & marketing, partnerships",
  "social impact",
  "strategy & consulting",
  "telecom",
  "vc & fin services",
];

function EditIndustryDialog({ tagsAndIndustry, onClose }: any) {
  const [chosenValues, setChosenValues] = useState<string[]>(
    tagsAndIndustry.filter((eachTag: string) =>
      PROFILE_DIRECTORIES_OPTIONS.includes(eachTag)
    )
  );
  const [updateIndustryTags, { isLoading: isUpdateIndustryTagsLoading }] =
    useUpdateIndustryTagsMutation();

  const { enqueueSnackbar } = useSnackbar();

  const onUpdateHandler = async () => {
    try {
      if (!chosenValues.length) {
        return enqueueSnackbar("please select atleast one option", {
          variant: "error",
        });
      }
      if (chosenValues.length > 3) {
        return enqueueSnackbar("please select only 3 tags", {
          variant: "error",
        });
      }
      await updateIndustryTags(chosenValues).unwrap();
      enqueueSnackbar("profile details updated!", {
        variant: "success",
      });
      onClose();
    } catch (error) {
      console.error(error);
      enqueueSnackbar("failed to update your details", {
        variant: "error",
      });
    }
  };

  const onTagPress = (tag: string) => {
    if (chosenValues?.find((id) => id === tag)) {
      const newTags = chosenValues?.filter((id) => id !== tag);
      setChosenValues(newTags);
    } else {
      setChosenValues((prevValues) => [...prevValues, tag]);
    }
  };

  return (
    <>
      <CustomDialogTitle onClose={onClose}>
        <Typography>edit tags & industries (max 3)</Typography>
      </CustomDialogTitle>
      <DialogContent dividers>
        <Stack direction="row" flexWrap="wrap">
          {PROFILE_DIRECTORIES_OPTIONS.map((tag) => {
            return (
              <Chip
                key={tag}
                label={tag}
                size="small"
                variant={
                  chosenValues?.find((id) => id === tag) ? "filled" : "outlined"
                }
                color={
                  chosenValues?.find((id) => id === tag) === tag
                    ? "primary"
                    : "default"
                }
                sx={{
                  mr: 1,
                  mb: 2,
                  fontSize: 12,
                  pl: 1.5,
                  pr: 1.5,
                  paddingTop: 1.7,
                  paddingBottom: 1.7,
                }}
                onClick={() => onTagPress(tag)}
              />
            );
          })}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          cancel
        </Button>
        <LoadingButton
          variant="text"
          type="submit"
          loading={isUpdateIndustryTagsLoading}
          onClick={onUpdateHandler}
        >
          update
        </LoadingButton>
      </DialogActions>
    </>
  );
}

export default EditIndustryDialog;
